import {MouseEvent} from 'react';
import styled from 'styled-components';
import {LoadingBar} from '@/components/LoadingBar';
import {Modal} from '@/components/Modal';
import {Typography, typographyStyle} from '@/components/Typography';
import {useMapDataSource} from '@/map/api';
import {FlexCenter, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';

interface IProps {
  onClose?(e: MouseEvent<HTMLButtonElement>): void;
}

export const DataSourceModal = ({onClose}: IProps) => {
  const {data, isLoading} = useMapDataSource();

  return (
    <Modal title="지도 데이터 출처" width={500} onClose={onClose}>
      <Root>
        <Row className="header">
          <Cell>데이터</Cell>
          <Cell style={{flexGrow: 1}}>출처</Cell>
          <Cell>데이터 기준일</Cell>
        </Row>
        {!!data?.length ? (
          data.map((i) => (
            <Row key={i.data}>
              <Cell>{i.data}</Cell>
              <Cell style={{flexGrow: 1}}>{i.source}</Cell>
              <Cell>{i.baseDate}</Cell>
            </Row>
          ))
        ) : isLoading ? (
          <PaddingBox spacing={24}>
            <FlexCenter>
              <LoadingBar />
            </FlexCenter>
          </PaddingBox>
        ) : (
          <PaddingBox spacing={[24, 12]}>
            <Typography variant="medium14" align="center">
              데이터 출처 정보가 없습니다.
            </Typography>
          </PaddingBox>
        )}
      </Root>
    </Modal>
  );
};

const Root = styled.div`
  padding: 16px;
`;

const Row = styled.div`
  display: flex;
  color: ${palette.textSecondary};
  font-weight: 500;
  ${{...typographyStyle.medium12}}
  &.header {
    background-color: ${palette.gray200};
    color: ${palette.textPrimary};
    border-top: solid 1px ${palette.gray200};
  }
  border-bottom: solid 1px ${palette.gray200};
`;

const Cell = styled.div`
  padding: 4px;
  &:first-of-type {
    flex-basis: 180px;
    flex-shrink: 0;
  }
  &:last-of-type {
    flex-basis: 80px;
    flex-shrink: 0;
  }
  & + & {
    border-left: solid 1px ${palette.gray200};
  }
`;
